import type { ReactNode } from "react";
import Reveal from "./Reveal";
import { cn } from "@/utils/cn";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "center" | "left";
  className?: string;
  as?: "h1" | "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className,
  as: Tag = "h2",
}: SectionHeadingProps) {
  return (
    <Reveal
      className={cn(
        "flex flex-col gap-3",
        align === "center" ? "items-center text-center mx-auto max-w-2xl" : "items-start text-left max-w-2xl",
        className
      )}
    >
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs font-label font-semibold uppercase tracking-wide text-accent-900">
          <i className="ri-map-pin-2-line text-[13px]" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <Tag className="text-2xl md:text-4xl font-heading font-semibold leading-tight text-foreground-950">
        {title}
      </Tag>
      {description && <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{description}</p>}
    </Reveal>
  );
}